import { makeRequest } from 'utils/requestLogger';
// store.dispatch('updateSubmissionFlag', res);

export default (submissionID) =>
  makeRequest('put', `/api/submissions/${submissionID}/toggle-flag`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/flagSubmission.js